import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { completeOnboarding } from "@/features/onboarding/api";
import { ONBOARDING_ROUTE } from "@/features/onboarding/router";
import { useOnboardingStore } from "@/features/onboarding/stores";
import { SUBSCRIPTION_VENDOR } from "@/shared/domains";
import { errorToast } from "@/shared/ui";

export const useCompleteOnboarding = ({
  onNeedsWhiteCoatSync,
}: {
  onNeedsWhiteCoatSync?: VoidFunction;
} = {}) => {
  const navigate = useNavigate();

  const setUserToken = useOnboardingStore((state) => state.setUserToken);

  return useMutation({
    mutationFn: completeOnboarding,
    onSuccess: ({ token, intakeResult }) => {
      setUserToken(token);

      if (
        onNeedsWhiteCoatSync &&
        intakeResult?.needsSync &&
        intakeResult.vendor === SUBSCRIPTION_VENDOR.WHITE_COAT
      ) {
        onNeedsWhiteCoatSync();
        return;
      }

      navigate(ONBOARDING_ROUTE.ACCOUNT_PASSWORD);
    },
    onError: errorToast,
  });
};
